import useSWR, { SWRResponse } from "swr";
import request, { ApiError } from "./common";
import { ProjectUserRole } from "../types/project";

const path = "/admin";

const adminApi = {
    superadminrights: (
        payload: SuperAdminRightsRequest,
        userId: string,
    ): Promise<null> => {
        return request<null, SuperAdminRightsRequest>(
            `${path}/id/${userId}/superadminrights`,
            "PATCH",
            payload,
        );
    },
};

export const useRoleList = (): SWRResponse<string[], ApiError> => {
    return useSWR<string[], ApiError>(`${path}/roles/profile-type`, request);
};

export const useRoleListByProfileType = (
    profileType: string | undefined,
): SWRResponse<ProjectUserRole[], ApiError> => {
    return useSWR<ProjectUserRole[], ApiError>(
        () =>
            profileType ? `${path}/roles/profile-type/${profileType}` : null,
        request,
    );
};

export type SuperAdminRightsRequest = {
    isEntityManagement: boolean;
    isUserManagement: boolean;
};

export default adminApi;
